export enum ProviderDataReviewType {
  providerSpecialtyDataReview = 'ProviderSpecialtyDataReview',
  providerFaxNumberDataReview = 'ProviderFaxNumberDataReview',
}

export enum ProviderDataReviewPageTitle {
  providerSpecialtyDataReview = 'Specialty',
  providerFaxNumberDataReview = 'Fax Number',
}

export enum ProviderDataReviewTypeQueryString {
  providerSpecialtyDataReview = 'specialty',
  providerFaxNumberDataReview = 'fax-number',
}
